export function getEmailAddress(pcd) {
    return pcd?.claim?.emailAddress;
}
export function getPublicKey(pcd) {
    return pcd?.proof?.eddsaPCD?.claim?.publicKey;
}
